import '.ab{margin-bottom:5rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ac{align-items:stretch;}.ssr-plugin'
import { ReactNode } from 'react'
import { Style, styled } from 'inlines'
import TopNavBar from '@app/components/blocks/navbar/main/TopNavBar'
import Footer from '@app/components/blocks/footer/Footer'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Head } from '@based/sdk/react'
import { useLocation } from 'wouter'
import { useRootDomain } from '@app/util/hooks/useRootDomain'
import { useTenantContext } from '@app/util/contexts/TenantContext'
import { ResponsiveContainer } from '@app/components/layout/ResponsiveContainer'
import Column from '@app/components/layout/Column'

export const PageLayout = ({
  gap = '1rem',
  standardPageTitle = true,
  children,
  marginTop = '2rem',
  style,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  standardPageTitle?: boolean
  children: ReactNode
  marginTop?: string
  style?: Style
}) => {
  const isMobile = useMediaQuery()
  const [location] = useLocation()
  const rootDomain = useRootDomain()
  const { title, navigationComponent, footerComponent } = useTenantContext()

  return (
    <Column
      alignItems="center"
      style={{
        justifyContent: 'center',
        background: 'var(--page-bg)',
        ...style,
      }}
    >
      {standardPageTitle && (
        <Head>
          <title>{title}</title>
        </Head>
      )}
      <Head>
        <link rel="canonical" href={`${rootDomain}${location}`} />
      </Head>
      {navigationComponent ?? <TopNavBar />}

      <ResponsiveContainer
        style={{
          minHeight: '100vh',
          marginBottom: '2rem',
        }}
      >
        <styled.main className="ab d e ac"
          style={{
            marginTop,
            gap: gap,
            paddingInline: isMobile ? 0 : '1rem',
          }}
        >
          {children}
        </styled.main>
      </ResponsiveContainer>

      {footerComponent ?? <Footer />}
    </Column>
  )
}
